var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c(
        "a-row",
        { attrs: { type: "flex" } },
        [
          _c("a-col", { attrs: { flex: "280px" } }, [
            _c(
              "div",
              {
                staticClass: "flex-between",
                staticStyle: { "margin-bottom": "10px" },
              },
              [
                _c("span", { staticClass: "title-2" }, [_vm._v("教师成长")]),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.createLeague },
                  },
                  [_vm._v("创建课题")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "collapse" },
              [
                _c(
                  "a-collapse",
                  {
                    model: {
                      value: _vm.activeKey,
                      callback: function ($$v) {
                        _vm.activeKey = $$v
                      },
                      expression: "activeKey",
                    },
                  },
                  _vm._l(_vm.collapseList, function (item) {
                    return _c(
                      "a-collapse-panel",
                      {
                        key: item.key,
                        staticStyle: {
                          "background-color": "#eff2f5",
                          cursor: "pointer",
                        },
                        attrs: { header: item.header },
                      },
                      _vm._l(item.children, function (child) {
                        return _c(
                          "div",
                          {
                            key: child.key,
                            staticStyle: {
                              "padding-left": "24px",
                              color: "#258ae9",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectItem(child.key)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(child.header) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "a-col",
            { attrs: { flex: "2px" } },
            [
              _c("a-divider", {
                staticStyle: { height: "700px" },
                attrs: { type: "vertical" },
              }),
            ],
            1
          ),
          _c("a-col", { attrs: { flex: "auto" } }, [_vm._v("auto")]),
        ],
        1
      ),
      _c("CreateSubjectModal", { ref: "createSubjectModalRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }